import { apiBasic, apiGet } from "./requests";

export const getOptions = () => {
  let path = "option/";
  return apiGet(path);
};

export const createOption = (payload) => {
  let path = "option/";
  return apiBasic(payload, path, "post");
};

export const updateOption = (payload, idGroup, id) => {
  let path = `option/${id}/option-group/${idGroup}`;
  return apiBasic(payload, path, "patch");
};

export const getOptionGroups = () => {
  let path = "option-groups/";
  return apiGet(path);
};

export const createOptionGroup = (payload) => {
  console.log("payload", payload);
  let path = "option-group/";
  return apiBasic(payload, path, "post");
};

export const updateOptionGroup = (payload, id) => {
  console.log("payload", payload);
  let path = `option-group/${id}`;
  return apiBasic(payload, path, "patch");
};

export const toggleOptions = (categoryId, productId) => {
  let path = `options/${categoryId}/toogle`;
  return apiBasic({ productId }, path);
};

/* PRODUCT */

// Añadir grupo de opciones al producto desde el handler OK
export const addOptionsGroupToProduct = (productId, data) => {
  let path = `product/${productId}/add-options`;
  return apiBasic(data, path, "patch");
};

// Eliminar grupo activo de un producto OK
export const removeGroupFromProduct = (productId, optionGroupId) => {
  let path = `product/${productId}/option-group/${optionGroupId}`;
  return apiBasic({}, path, "delete");
};

// Elimina una opcion de un producto OK
export const removeOptionFromProduct = (productId, optionId) => {
  let path = `product/${productId}/option/${optionId}`;
  return apiBasic({}, path, "delete");
};
